import frozenLogo from "../../_asset/image/logo/pateklogo.png"

export default function Logo({ link }: { link: boolean }) {
    function MoveRoot() {
        if (link) {
            window.location.href = '/'
        }
    }
    return (
        <div className={`logo ${link ? '--pointer' : ''}`} onClick={MoveRoot}>
            <img src={frozenLogo} alt="" />
            <p></p>
        </div>
    )
}

Logo.defaultProps = {
    link: false
}